export default __webpack_public_path__ + "static/media/contact-us.05be758a.jpg";